import { Neo } from "@singularsystems/neo-react";
import { observer } from "mobx-react";
import React from "react";
import ManageBrokerSFTPDetailsComponentVM from "./ManageBrokerSFTPDetailsComponentVM";
import { List, Validation } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";
import TradeSftpTypeLookup from "../Models/Lookups/TradeSftpTypeLookup";

interface IManageBrokerSFTPDetailsComponentProps {
    viewModel: ManageBrokerSFTPDetailsComponentVM;
    sftpTypeOptions: List<TradeSftpTypeLookup>;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageBrokerSFTPDetailsComponent extends React.Component<IManageBrokerSFTPDetailsComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;
        return (
            <div>
                <Neo.Form
                    model={viewModel.managedBrokerSFTPDetails}
                    onSubmit={() => viewModel.managedBrokerSFTPDetails.staticServiceProviderSftpdetailsId > 0 ? viewModel.updateSFTPDetails() : viewModel.addSFTPDetails() }
                    validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                >
                    <Neo.Card title={`${TextConstants.Titles.EditSFTPDetails}`}>
                        <Neo.GridLayout lg={3}>
                            {viewModel.managedBrokerSFTPDetails.staticServiceProviderSftpdetailsId > 0 ?
                            <Neo.FormGroupInline label={TextConstants.Labels.SFTPSetting} display={viewModel.managedBrokerSFTPDetails.meta.sftpSetting} />
                            :

                            <Neo.FormGroupInline
                                    label={TextConstants.Labels.SFTPSetting}
                                    bind={viewModel.selectedSftpDetail.meta.sftpdetailId}
                                    select={{ items: viewModel.sftpDetailsList, displayMember: "sftpSetting", valueMember: "sftpdetailId", }}
                                    onChange={() => viewModel.setSftpDetails()}
                                    />
                            }
                            <Neo.FormGroupInline label={TextConstants.Labels.SFTPDirectory} bind={viewModel.managedBrokerSFTPDetails.meta.sftpDirectory} />
                            <Neo.FormGroupInline label={TextConstants.Labels.PrimeTimeCronSchedule} bind={viewModel.managedBrokerSFTPDetails.meta.primeTimeCron} />
                        </Neo.GridLayout>
                        <Neo.GridLayout lg={3}>
                            <Neo.FormGroupInline label={TextConstants.Labels.LateCronSchedule} bind={viewModel.managedBrokerSFTPDetails.meta.lateCron} />
                                 </Neo.GridLayout>
                                    <Neo.GridLayout lg={3}>
                                        <Neo.FormGroupInline label={"Trade SFTP Type"}>
                                            <Neo.DropDown
                                                select={{
                                                    items: this.props.sftpTypeOptions,
                                                    allowNulls: true
                                                }
                                                }
                                                bind={this.props.viewModel.managedBrokerSFTPDetails.meta.tradeSftpTypeId}
                                                placeholder="Select Trade SFTP Type"
                                            />
                                        </Neo.FormGroupInline>
                                    </Neo.GridLayout>
                        <Neo.GridLayout lg={3}>
                            <Neo.FormGroupInline label={TextConstants.Labels.ExportLocation} bind={viewModel.managedBrokerSFTPDetails.meta.isExportInd} />
                            <Neo.FormGroupInline label={TextConstants.Labels.IsActive} bind={viewModel.managedBrokerSFTPDetails.meta.isActiveInd} />
                            <Neo.FormGroupInline
                                label={TextConstants.Labels.IsTradeOrder}
                                bind={viewModel.managedBrokerSFTPDetails.meta.isTradeOrder}
                                type="checkbox"
                        />
                        <Neo.FormGroupInline
                                label={TextConstants.Labels.IsValuation}
                                bind={viewModel.managedBrokerSFTPDetails.meta.isValuation}
                                type="checkbox"
                        />
                        </Neo.GridLayout>
                        <div className="row customMarginTop29 float-right pr-3">
                            <Neo.Button
                                variant="primary" className="ml-3 col-md-2" isSubmit
                            >{TextConstants.Buttons.Save}</Neo.Button>
                            <Neo.Button className="ml-3 col-md-2"
                                onClick={() => this.props.onCancel()}
                                variant="secondary"
                            >{TextConstants.Buttons.Cancel}</Neo.Button>
                        </div>
                    </Neo.Card>
                </Neo.Form>
            </div>
        );
    }
}